import Abstract from './abstract';

export default class ABTestingView extends Abstract {
  init() {
    this.getElement();

    this.setViewPattern();

    this.addEvent();
  }

  getElement() {
  }

  setViewPattern() {
  }

  addEvent() {
  }
}
